import { render } from "./filterItem.vue?vue&type=template&id=04bec160"
import script from "./filterItem.vue?vue&type=script&lang=js"
export * from "./filterItem.vue?vue&type=script&lang=js"

import "./filterItem.vue?vue&type=style&index=0&id=04bec160&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__